export default class JoyObjectObserver {
    constructor(updateFunction) {
        this.updateFunction = updateFunction;
    }
    notify(update) {
        this.updateFunction(update);
    }
}
//# sourceMappingURL=JoyObjectObserver.js.map